/*eslint-disable*/
import { usePost, useGetUnAuthorizedAdmin } from "./useRequest";
export const handleCandidateFirstLogin = () => {
    const path = `/usermanagement/handlecandidatefirstlogin`;
    const response = usePost(path);
    return response;
  };

  export function handleOAuthRedirect(redirectUri, jobId) {
    const path = `/jobs/user/oauth/${jobId}/?redirectUri=${redirectUri}`;
    return useGetUnAuthorizedAdmin(path);
  }